export default __webpack_public_path__ + "static/media/manejo_via_aerea_artificial.7635b0c4.pdf";